import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const eyeableScriptDomain = useScript({"src":"https://cdn.eye-able.com/configs/cultus-dresden.de.js","key":"eyeableScriptDomain"}, { use: () => ({ eyeableScriptDomain: window.eyeableScriptDomain }) })
    const eyeableScript = useScript({"src":"https://cdn.eye-able.com/public/js/eyeAble.js","key":"eyeableScript"}, { use: () => ({ eyeableScript: window.eyeableScript }) })
    return { provide: { $scripts: { eyeableScriptDomain, eyeableScript } } }
  }
})